/*
 * @Author: Teemo Ding
 * @Date: 2021-10-18 14:56:45
 * @LastEditTime: 2022-04-13 16:11:22
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/tools/config.ts
 */
import { ConditionType, UnitType } from '@/src/types/common/common';
import { getI18nFromGeneral } from './tools';
export const ICON_HOST_URL = 'https://resource2.unifyxp.com/icon/iconfont.js';

export const KF_URL = 'https://kf.unifyxp.com/s/806200xuv';

export const IMAGE_BASE_URL = 'https://resource2.unifyxp.com/unifyxp2/default';
export const ACCOUNT_INFO = 'ACCOUNT_INFO';

export const unitTypeList = {
  [ConditionType.Weight]: [
    {
      label: getI18nFromGeneral('general.unit.metric'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.kilogram')} (kg)`,
          value: UnitType.Kilogram,
        },
        {
          label: `${getI18nFromGeneral('general.unit.gram')} (g)`,
          value: UnitType.Gram,
        },
      ],
    },
    {
      label: getI18nFromGeneral('general.unit.imperial'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.pound')} (lb)`,
          value: UnitType.Pound,
        },
        {
          label: `${getI18nFromGeneral('general.unit.ounce')} (oz.)`,
          value: UnitType.Ounce,
        },
      ],
    },
  ],
  // [ConditionType.Volume]: [
  //   {
  //     label: 'Metric',
  //     children: [
  //       {
  //         label: 'cubic metre (m3)',
  //         value: UnitType.CubicMetre,
  //       },
  //       {
  //         label: 'cubic centimeter (cm3)',
  //         value: UnitType.CubicCentimetre,
  //       },
  //     ],
  //   },
  //   {
  //     label: 'Imperial',
  //     children: [
  //       {
  //         label: 'cubic foot (ft3)',
  //         value: UnitType.CubicFoot,
  //       },
  //       {
  //         label: 'cubic inch (in3)',
  //         value: UnitType.CubicInch,
  //       },
  //     ],
  //   },
  // ],
  [ConditionType.Size]: [
    {
      label: getI18nFromGeneral('general.unit.metric'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.cubicmetre')} (m3)`,
          value: UnitType.CubicMetre,
        },
        {
          label: `${getI18nFromGeneral('general.unit.cubiccentimeter')} (cm3)`,
          value: UnitType.CubicCentimetre,
        },
      ],
    },
    {
      label: getI18nFromGeneral('general.unit.imperial'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.cubicfoot')} (ft3)`,
          value: UnitType.CubicFoot,
        },
        {
          label: `${getI18nFromGeneral('general.unit.cubicinch')} (in3)`,
          value: UnitType.CubicInch,
        },
      ],
    },
  ],
  [ConditionType.Length]: [
    {
      label: getI18nFromGeneral('general.unit.metric'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.metre')} (m)`,
          value: UnitType.Metre,
        },
        {
          label: `${getI18nFromGeneral('general.unit.centimetre')} (cm)`,
          value: UnitType.Centimetre,
        },
      ],
    },
    {
      label: getI18nFromGeneral('general.unit.imperial'),
      children: [
        {
          label: `${getI18nFromGeneral('general.unit.foot')} (ft)`,
          value: UnitType.Foot,
        },
        {
          label: `${getI18nFromGeneral('general.unit.inch')} (in)`,
          value: UnitType.Inch,
        },
      ],
    },
  ],
};

export const unitSuffix = {
  [UnitType.Ounce]: 'oz.',
  [UnitType.Pound]: 'lb',
  [UnitType.Gram]: 'g',
  [UnitType.Kilogram]: 'kg',
  [UnitType.CubicInch]: 'in3',
  [UnitType.CubicFoot]: 'ft3',
  [UnitType.CubicCentimetre]: 'cm3',
  [UnitType.CubicMetre]: 'm3',
  [UnitType.Metre]: 'm',
  [UnitType.Centimetre]: 'cm',
  [UnitType.Foot]: 'ft',
  [UnitType.Inch]: 'in',
};

export const unitDict = {
  [UnitType.Kilogram]: `${getI18nFromGeneral('general.unit.kilogram')} (kg)`,
  [UnitType.Ounce]: `${getI18nFromGeneral('general.unit.ounce')} (oz.)`,
  [UnitType.Pound]: `${getI18nFromGeneral('general.unit.pound')} (lb)`,
  [UnitType.Gram]: `${getI18nFromGeneral('general.unit.gram')} (g)`,
};
